import type { DocumentGroupEntryPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import type { DocumentEntryView } from '@UI/Store/Documents/Views/buildDocumentEntryView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A nested `object` node, `type: 'group'` discriminant. A pure data holder: `entries` arrives
 * already built — the recursion that resolves the field/group/list union lives in
 * `buildDocumentEntryView` alone, so this class never has to import it back.
 */
class DocumentGroupView {
	readonly type: 'group';
	readonly uuid: string;
	readonly path: string;
	readonly title: string;
	readonly description: string | null;
	readonly entries: readonly DocumentEntryView[];

	constructor(
		payload: Pick<DocumentGroupEntryPayload, 'uuid' | 'path' | 'title' | 'description'>,
		entries: readonly DocumentEntryView[],
	) {
		this.type = 'group';
		this.uuid = payload.uuid;
		this.path = payload.path;
		this.title = payload.title;
		this.description = payload.description;
		this.entries = entries;

		Object.freeze(this);
	}
}

export default DocumentGroupView;
